import React from 'react'

import { theme } from '@factorialco/deprecated-design-system'
import { InAppCommsMedia } from 'generated/resources/datatable.graphql'

interface StepMediaProps {
  media: Array<InAppCommsMedia>
}

const StepMedia = ({ media }: StepMediaProps) => {
  if (!media?.[0]?.url) return null

  const mediaUrl = media[0].url
  const isVideo = /\.(mp4|webm|ogg|mov|avi)$/i.test(mediaUrl)
  const commonStyles = {
    borderRadius: theme.dimensions.s12,
    margin: '4px 4px 0 4px',
    aspectRatio: '16/9',
    backgroundColor: theme.colors.grey300,
  }

  return isVideo ? (
    <video
      src={mediaUrl}
      style={{
        ...commonStyles,
        pointerEvents: 'none',
      }}
      autoPlay
      muted
      loop
      playsInline
    />
  ) : (
    <img src={mediaUrl} style={commonStyles} />
  )
}

export default StepMedia

